import React, { useEffect, useState } from "react";
import { Link, usePage } from '@inertiajs/react'


export default function Product({ product }) {
    return (
        <div className="w-full flex flex-col hover:border hover:border-blue-500 rounded border">
            <div className="flex items-center justify-center p-5">
                <Link className="h-[192px] flex justify-center items-center" href={`/products/${product.alias}`}>
                    <img className="w-100 max-h-[192px]" src={product.primaryImage?.url} />
                </Link>

            </div>
            <div className="p-5">
                <div className="text-xs text-gray-600">
                    {product.categories.length > 0 ? (
                        <>
                            <a href={`/categories/${product.categories[0].alias}`}>{product.categories[0].name}</a> | <a href={`/categories/${product.categories[0].alias}?brands=${product.brand_id}`}>{product.brand?.name}</a>
                            {product.series.length > 0 ? ' | Series' : null}
                        </>
                    ) : null}
                </div>
                <div className="h-10 text-sm overflow-hidden text-ellipsis">
                    <Link className="" href={`/products/${product.alias}`}>
                        {product.name}
                    </Link>
                </div>
                <div className="text-base mt-2 flex items-center gap-x-1 font-medium">
                    {product.available ? (
                        <>

                            {
                                product.storeProducts.length > 1 ? (
                                    'from '
                                ) : null
                            }
                            <span className="text-blue-500">${Number(product.storeProducts[0].price.sale_price / 100).toFixed(2)} </span>

                            {product.storeProducts[0].price.sale_price < product.storeProducts[0].price.regular_price ? (
                                <span className="text-white bg-red-500 px-2 py-1 rounded">SALE</span>
                            ) : null}

                            {product.storeProducts[0].marketplace ? (
                                <span className="text-white bg-blue-500 px-2 py-1 rounded">MP</span>
                            ) : null}

                        </>
                    ) : (
                        "Not available"
                    )}
                </div>
            </div>
        </div >
    )
}